import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React from "react";

export const Shield = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 3.48697L5.11132 6.58266V11.2262C5.11132 12.9184 5.56752 14.5674 6.36196 16.0041L17.8804 6.12957L12 3.48697ZM18.8886 7.78658L7.4505 17.5923C8.64369 19.0155 10.2191 20.0735 12 20.5132C15.9494 19.5381 18.8886 15.5214 18.8886 11.2262V7.78658Z"
      fill="currentColor"
    />
  </SvgIcon>
);
